<template>
    <el-dialog title="批量导出元数据" width="50%"
               :close-on-click-modal="false"
               append-to-body :visible.sync="visible">
        <el-form size="small" :model="form" ref="form">
            <el-form-item label="模板选择：" prop="id">
                <div class="flex_l_c">
                    <el-select v-model="form.id" placeholder="请选择模板" filterable clearable class="m_r1 flex_1" @change="selName">
                        <el-option
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                v-for="item in templateOpt">
                        </el-option>
                    </el-select>
                    <el-link type="primary" :underline="false" class="el-icon-s-tools" @click="getTemplate()"></el-link>
                </div>
            </el-form-item>
            <el-transfer v-loading="loading" filterable
                         ref="transfer"
                         v-model="form.selId"
                         :titles="['选择数据', '已选数据']"
                         target-order="push"
                         :props="{key: 'id',label: 'fieldName'}"
                         :data="transferData">
                      <span slot-scope="{ option }">
                        {{ option.fieldName }}
                      </span>
            </el-transfer>
            <el-form-item label="是否保存模板：" prop="saveMode" class="m_t1" v-if="!form.id">
                <el-switch v-model="form.saveMode" active-value="0" inactive-value="1" @change="form.name = ''" ></el-switch>
            </el-form-item>
            <el-form-item label-width="100px" label="模板名称：" prop="name" v-if="!form.id && form.saveMode == '0'" :rules="[{required: true, message: '模板名称不能为空', trigger: 'blur'}]">
                <el-input v-model.trim="form.name" placeholder="请输入模板名称（限10字）" clearable maxlength="10"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" :disabled="loading" @click="doSubmit()" v-noMoreClick>导出</el-button>
        </div>
        <ExportTemplate ref="exportTemplate" @refreshDataList="getTemplateSel()"></ExportTemplate>
    </el-dialog>
</template>

<script>
    import Sortable from 'sortablejs'
    import ExportTemplate from './exportTemplate'

    export default {
        components: {ExportTemplate},
        data() {
            return {
                visible: false,
                loading: false,
                templateOpt: [],
                form: {
                    id: '',
                    name: '',
                    saveMode: '1',
                    selId: [],
                    selectId: [],
                    selectList: []
                },
                transferData: [],
            }
        },
        methods: {
            init(idList) {
                this.form.selectId = idList
                this.form.selId = []
                this.templateOpt = []
                this.transferData = []
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.initSortable()
                    this.getInitData()
                    this.getTemplateSel()
                })
            },
            // 获取初始化数据
            getInitData() {
                this.loading = true
                this.form.selId = []
                this.form.selectList = []
                this.$axios(this.api.metadata.businessinit).then(res => {
                    if(res.status) {
                        this.transferData = res.data
                    } else {
                        this.$message.error(res.msg)
                    }
                    this.loading = false
                })
            },
            // 获取模板选择
            getTemplateSel() {
                this.$axios(this.api.metadata.allList).then(res => {
                    if(res.status) {
                        this.templateOpt = res.data
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            },
            // 设置模板
            getTemplate() {
                this.$refs.exportTemplate.init(this.form.id)
            },
            // 初始化拖拽排序
            initSortable() {
                const that = this
                const transfer = this.$refs.transfer.$el
                const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1].getElementsByClassName('el-transfer-panel__body')[0]
                const rightEl = rightPanel.getElementsByClassName('el-transfer-panel__list')[0]
                Sortable.create(rightEl, {
                    onEnd({ newIndex, oldIndex }) {
                        that.form.selId.splice(newIndex, 0, that.form.selId.splice(oldIndex, 1)[0])
                        const newArray = that.form.selId.slice(0)
                        that.form.selId = []
                        that.$nextTick(function () {
                            that.form.selId = newArray
                        })
                    }
                })
            },
            // 选择模板
            selName(id) {
                this.form.name = ''
                this.form.saveMode = '1'
                if(id) {
                    this.form.name = this.templateOpt.filter(v => id == v.id)[0].name
                    this.getTemplateInfo()
                } else {
                    this.getInitData()
                }
            },
            // 获取模板字段
            getTemplateInfo() {
                this.loading = true
                this.form.selId = []
                this.$axios(this.api.metadata.selectInfo + '/' + this.form.id).then(res => {
                    if(res.status) {
                        this.transferData = res.data.selectList.concat(res.data.uncheckedList)
                        res.data.selectList.map(item => {
                            this.form.selId.push(item.id)
                        })
                    } else {
                        this.$message.error(res.msg)
                    }
                    this.loading = false
                })
            },
            doSubmit() {
                if (!this.form.selId.length) {
                    this.$message.warning('请选择需要导出的数据！')
                    return
                }
                if(this.form.saveMode == '0') {
                    this.$axios(this.api.metadata.findModeNumByUserId, {}, 'post').then(res => {
                        if(res.status) {
                            if(res.data < 20) {
                                this.saveData()
                            } else {
                                this.$message.warning('模板数量已达上限！')
                            }
                        }
                    })
                } else {
                    this.saveData()
                }
            },
            saveData() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.form.selectList = []
                        this.form.selId.map(id => {
                            this.transferData.map(item => {
                                if(id == item.id) {
                                    this.form.selectList.push(item)
                                }
                            })
                        })
                        this.$nextTick(() => {
                            let fileName = this.form.name ? this.form.name : '元数据管理导出'
                            this.$axios(this.api.metadata.businessExport, this.form, 'post', 'blob').then(response => {
                                let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
                                let link = document.createElement('a')
                                link.download = decodeURI(fileName)
                                link.href = window.URL.createObjectURL(blob)
                                link.click()
                                this.$nextTick(() => {
                                    this.visible = false
                                })
                            }).catch((error) => {
                                this.$message.error('导出失败')
                            })
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .el-transfer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .el-transfer >>> .el-transfer-panel {
        width: 35% !important;
    }

    .el-icon-s-tools {
        font-size: 18px;
    }
</style>
